export function ErrorLine({ onRetry, message = 'Something went wrong.' }: { onRetry?: () => void; message?: string }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-l-[3px] border-l-red bg-redTint px-4 py-3">
      <p className="font-cond text-[16px] font-semibold uppercase tracking-[0.06em] text-red">{message}</p>
      {onRetry && <button onClick={onRetry} className="btn-secondary btn-sm">Retry</button>}
    </div>
  );
}
